import { PERMISSIONS } from "../config/permissions";

export const normalizePermissions = (permissions = []) =>
    Array.isArray(permissions)
        ? permissions.map((permission) => String(permission || "").toUpperCase()).filter(Boolean)
        : [];

export const hasPermission = (user, permission) => {
    if (!permission) return true;
    if (permission === PERMISSIONS.DASHBOARD) return Boolean(user);

    const permissions = normalizePermissions(user?.permissions);
    if (permissions.includes(PERMISSIONS.ALL) || permissions.includes(PERMISSIONS.ADMIN)) return true;
    if (permissions.length === 0) return permission === PERMISSIONS.DASHBOARD;
    return permissions.includes(permission);
};

export const hasAnyPermission = (user, permissions = []) =>
    permissions.some((permission) => hasPermission(user, permission));
